let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("czC5b")).then(() => parcelRequire('d1GUC'));